// extracted by mini-css-extract-plugin
module.exports = {"label":"MyAccountViewItem_label__GoCLo","value":"MyAccountViewItem_value__3izK0","underlined":"MyAccountViewItem_underlined__rV3eo","rotation":"MyAccountViewItem_rotation__dNSPW"};